export interface WordType {
  topPosition: number;
  english: string;
  korean: string;
  color: string;
  position?: number;
  leftPosition?: number;
}

export const typingData = [
  { english: "acquaintance", korean: "지인", color: "#00A3FF" },
  { english: "beverage", korean: "음료", color: "#51D600" },
  { english: "courage", korean: "용기", color: "#FF9900" },
  { english: "disaster", korean: "재해", color: "#FF6DB3" },
  { english: "envelope", korean: "봉투", color: "#00A3FF" },
  { english: "festival", korean: "축제", color: "#51D600" },
  { english: "giraffe", korean: "기린", color: "#FF9900" },
  { english: "horizon", korean: "수평선", color: "#FF6DB3" },
  { english: "invention", korean: "발명", color: "#00A3FF" },
  { english: "jungle", korean: "정글", color: "#51D600" },
  { english: "keyboard", korean: "키보드", color: "#FF9900" },
  { english: "library", korean: "도서관", color: "#FF6DB3" },
  { english: "mansion", korean: "저택", color: "#00A3FF" },
  { english: "notebook", korean: "노트북", color: "#51D600" },
  { english: "oxygen", korean: "산소", color: "#FF9900" },
  { english: "parade", korean: "퍼레이드", color: "#FF6DB3" },
  { english: "quilt", korean: "이불", color: "#00A3FF" },
  { english: "recycle", korean: "재활용", color: "#51D600" },
  { english: "safeguard", korean: "보호하다", color: "#FF9900" },
  { english: "tourist", korean: "관광객", color: "#FF6DB3" },
  { english: "unique", korean: "독특한", color: "#00A3FF" },
  { english: "vaccine", korean: "백신", color: "#51D600" },
  { english: "whistle", korean: "호루라기", color: "#FF9900" },
  { english: "xylophone", korean: "실로폰", color: "#FF6DB3" },
  { english: "yacht", korean: "요트", color: "#00A3FF" },
  { english: "zealous", korean: "열광적인", color: "#51D600" },
  { english: "acumen", korean: "통찰력", color: "#FF9900" },
  { english: "breeze", korean: "산들바람", color: "#FF6DB3" },
  { english: "chronic", korean: "만성의", color: "#00A3FF" },
  { english: "delicate", korean: "섬세한", color: "#51D600" },
  { english: "elastic", korean: "탄력 있는", color: "#FF9900" },
  { english: "fascinate", korean: "매혹하다", color: "#FF6DB3" },
  { english: "gadget", korean: "기기", color: "#00A3FF" },
  { english: "hymn", korean: "찬송가", color: "#51D600" },
  { english: "immense", korean: "거대한", color: "#FF9900" },
  { english: "jovial", korean: "쾌활한", color: "#FF6DB3" },
  { english: "kinetic", korean: "운동의", color: "#00A3FF" },
  { english: "leisure", korean: "여가", color: "#51D600" },
  { english: "mysterious", korean: "신비로운", color: "#FF9900" },
  { english: "neat", korean: "깔끔한", color: "#FF6DB3" },
  { english: "opulent", korean: "호화로운", color: "#00A3FF" },
  { english: "platinum", korean: "백금", color: "#51D600" },
  { english: "quaint", korean: "멋진", color: "#FF9900" },
  { english: "resilient", korean: "회복력 있는", color: "#FF6DB3" },
  { english: "serene", korean: "평화로운", color: "#00A3FF" },
  { english: "tranquil", korean: "고요한", color: "#51D600" },
  { english: "vivid", korean: "선명한", color: "#FF9900" },
  { english: "whimsical", korean: "기발한", color: "#FF6DB3" },
  { english: "zephyr", korean: "미풍", color: "#00A3FF" },
];
